var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"kt-container",attrs:{"fluid":""}},[_c('b-row',[(!_vm.isAdmin)?_c('b-col',{attrs:{"xs":"12"}},[_c('h2',{staticClass:"text-left pl-5"},[_vm._v("Forbidden")])]):_vm._e(),(_vm.isAdmin)?_c('b-col',{attrs:{"xs":"12"}},[_c('ListingCategory',{attrs:{"title":_vm.$t('CATEGORIES.TITLE')}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }